import React from 'react';
import HeaderLinks from './headerLinks/HeaderLinks'

const About = () => (
  <div>
    <HeaderLinks/>
    
    ABout
  </div>
);

export default About;